"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeEnums = void 0;
function mergeEnums(base, derived) {
    return __assign(__assign({}, base), derived);
}
exports.mergeEnums = mergeEnums;
//# sourceMappingURL=helpers.js.map